// src/components/proposals/templateRegistry.js
//
// Maps a template key to its React component. Option A: each tier is its own
// independent document, so selecting a template means selecting a component —
// not toggling flags inside one adaptive template.
//
// Everything that renders a proposal goes through here (builder preview,
// template editor preview, and the print HTML sent to DocRaptor), so adding a
// tier is one entry rather than a hunt for hardcoded imports.
import BronzeTemplate from "./BronzeTemplate";
import GoldTemplate from "./GoldTemplate";
import SilverTemplate from "./SilverTemplate";
import LeadTemplate from "./LeadTemplate";

export const TEMPLATE_COMPONENTS = {
  "bronze-sentinel": BronzeTemplate,
  "silver-guardian": SilverTemplate,
  "gold-fortress":   GoldTemplate,
  // The Lead pre-proposal. Not a tier — a different DOCUMENT TYPE that happens
  // to route through the same registry, because every render path already goes
  // through here and a second mechanism would be one more place to forget.
  "lead-preproposal": LeadTemplate,
};

/* Falls back to Bronze rather than rendering nothing: a proposal whose
   templateKey doesn't resolve (a tier retired, or data from a newer build)
   should still open and export, not blank out.

   ⚠️ That fallback is only safe for records whose content is proposal-shaped.
   A Lead has an entirely different content shape, so a Lead whose key failed to
   resolve would render as a blank Bronze rather than as itself — which is why
   the key above must never be renamed without migrating stored records. */
export function templateComponentFor(key) {
  return TEMPLATE_COMPONENTS[key] || BronzeTemplate;
}
